module.exports = __webpack_public_path__ + "static/65gde-3f74440b56cec4ab5580b9c4c1c6a9dd.gif";